/*
 * Awhi — Stamped home carousel: full-review card heights.
 *
 * Stamped's carousel JS pins inline heights on the track and cards
 * (uniform, ~5 message lines), cropping long reviews and the author
 * line. CSS alone can't fix it: with the inline heights removed the
 * track collapses, because the slide elements don't size it in
 * normal flow. So after Stamped renders we measure the tallest
 * card's natural content and re-pin card + track heights to that.
 * Inline !important outranks Stamped's own (non-important) inline
 * styles, and re-runs cover resize and widget re-renders.
 */
(function () {
  'use strict';

  var WIDGET = '#stamped-reviews-widget[data-widget-type="carousel"]';
  var applying = false;
  var debounceTimer = null;

  function size() {
    var widget = document.querySelector(WIDGET);
    if (!widget) return;
    var wrapper = widget.querySelector('.stamped-carousel-scroll-wrapper');
    var scroll = widget.querySelector('.stamped-carousel-scroll');
    var blocks = widget.querySelectorAll('.stamped-carousel-scroll-wrapper .block');
    if (!wrapper || !scroll || !blocks.length) return;

    applying = true;

    var max = 0;
    var i;
    for (i = 0; i < blocks.length; i++) {
      blocks[i].style.setProperty('height', 'auto', 'important');
    }
    for (i = 0; i < blocks.length; i++) {
      if (blocks[i].offsetHeight > max) max = blocks[i].offsetHeight;
    }
    /* Equal cards again, but tall enough for the longest review */
    for (i = 0; i < blocks.length; i++) {
      blocks[i].style.setProperty('height', max + 'px', 'important');
    }
    wrapper.style.setProperty('height', max + 'px', 'important');

    /* The scroll box also holds the divider above the track — keep
       whatever headroom sits between its top and the track's top. */
    var headroom =
      wrapper.getBoundingClientRect().top - scroll.getBoundingClientRect().top;
    if (headroom < 0) headroom = 0;
    scroll.style.setProperty('height', headroom + max + 'px', 'important');

    window.requestAnimationFrame(function () {
      applying = false;
    });
  }

  function queueSize() {
    if (applying) return;
    if (debounceTimer) window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(size, 150);
  }

  /* Stamped injects the widget asynchronously — watch for it, then
     keep watching: it re-renders (and re-pins heights) on its own
     schedule. Child-list mutations only, so our style writes above
     don't feed back into the observer. */
  var observer = new MutationObserver(queueSize);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.addEventListener('resize', queueSize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueSize);
  } else {
    queueSize();
  }
})();
